/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SAMLProviderMini
 */
export interface SAMLProviderMini {
    /**
     * 
     * @type {number}
     * @memberof SAMLProviderMini
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SAMLProviderMini
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SAMLProviderMini
     */
    readonly loginUrl: string;
    /**
     * 
     * @type {string}
     * @memberof SAMLProviderMini
     */
    readonly logoutUrl: string;
}

export function SAMLProviderMiniFromJSON(json: any): SAMLProviderMini {
    return SAMLProviderMiniFromJSONTyped(json, false);
}

export function SAMLProviderMiniFromJSONTyped(json: any, ignoreDiscriminator: boolean): SAMLProviderMini {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'loginUrl': json['login_url'],
        'logoutUrl': json['logout_url'],
    };
}

export function SAMLProviderMiniToJSON(value?: SAMLProviderMini | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}


